import { Header } from '../aglsl/Header';
var Description = /** @class */ (function () {
    function Description() {
        var _a, _b;
        this.regread = (_a = {},
            _a[0 /* REGISTER.ATTR */] = [],
            _a[1 /* REGISTER.CONST */] = [],
            _a[4 /* REGISTER.VAR */] = [],
            _a[2 /* REGISTER.TEMP */] = [],
            _a[3 /* REGISTER.OUT */] = [],
            _a[5 /* REGISTER.SAMPLER */] = [],
            _a[15 /* REGISTER.NATIVE */] = [],
            _a);
        this.regwrite = (_b = {},
            _b[0 /* REGISTER.ATTR */] = [],
            _b[1 /* REGISTER.CONST */] = [],
            _b[4 /* REGISTER.VAR */] = [],
            _b[2 /* REGISTER.TEMP */] = [],
            _b[3 /* REGISTER.OUT */] = [],
            _b[5 /* REGISTER.SAMPLER */] = [],
            _b[15 /* REGISTER.NATIVE */] = [],
            _b);
        this.hasindirect = false;
        this.writedepth = false;
        this.hasmatrix = false;
        this.samplers = [];
        this.constants = 0;
        // added due to dynamic assignment 3*0xFFFFFFuuuu
        this.tokens = [];
        this.header = new Header();
        // native instructions per register
        this.native = {};
    }
    return Description;
}());
export { Description };
